import React, { useState, useEffect } from 'react';

const CleaningTable = ({ uId }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [pumpNumbers, setPumpNumbers] = useState([]);

    const itemsPerPage = 2;

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        const userId = uId;
        // alert(userId);
        fetch(`http://localhost:5000/latestPumpNumbers/${userId}`)
            .then(response => response.json())
            .then(data => {
                // Update state with fetched pump numbers
                setPumpNumbers(data.latestPumpData);
                // Calculate total pages based on the number of pump numbers fetched
                setTotalPages(Math.ceil(data.latestPumpData.length / itemsPerPage));
            })
            .catch(error => console.error('Error fetching data:', error));
    
        };

    const handleClick = (type) => {
        if (type === 'prev') {
            setCurrentPage(currentPage === 1 ? 1 : currentPage - 1);
        } else if (type === 'next') {
            setCurrentPage(currentPage === totalPages ? totalPages : currentPage + 1);
        }
    };
const rowStyle = {
    height: "20px",
    fontSize: "14px"
}
const small = {
    height: "30px",
    width: "25px",
    fontSize: "14px",
    marginTop: 0
}
const bottomshow = {
                    fontSize: "12px",
                     width: "150px", 
                     marginLeft: 0,
                     display: "flex",
                     justifyContent: "center",
                     alignItem: "center"
                    }
    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = pumpNumbers.slice(startIndex, endIndex);

        return currentItems.map((pump, index) => {
            // Parse the cl_date string into a Date object
            const clDate = new Date(pump.cl_date);
            // Format the clDate as per your requirement
            const formattedClDate = clDate.toISOString().replace('T', ' ').slice(0, -5);
            
            return (
                <tr key={index} className='cl-ingre' style={rowStyle}>
                    <td>{pump.pump_no}</td>
                    <td>{formattedClDate}</td> 
                </tr>
            );
        });
    };

    const smallMedia = window.innerWidth <= 768; // Adjust breakpoint as needed
if(pumpNumbers.length === 0){
    getData();
}
    return (
        <div className={`homeIngre ${smallMedia ? "homeIngre2" : ""}`}>
            <div className="stock-hh">
                <h4 className="custom-h-s">Cleaning</h4>
            </div>
            <div className='tb2 tb3'>
                <table className="customTable" style={{width: '100%', borderCollapse: 'separate', fontSize: '16px'}}>
                    <thead className="tb-head borderRow" style={{fontSize: '16px'}}>
                        <tr>
                            <th>Pump No</th>
                            <th>Date Time</th>
                        </tr>
                    </thead>
                    <tbody>{renderTableRows()}</tbody>
                </table>
            </div>
            <div className='bottomIngre cl_botom'>
                    <div className={`st-show ${smallMedia ? "st-show2" : ""}`} style={bottomshow}>
                        <div className="onscreen">Showing {Math.min(((currentPage - 1) * itemsPerPage) + 1, pumpNumbers.length)} to {Math.min(currentPage * itemsPerPage, pumpNumbers.length)}</div>
                        <div className="total">(Total {pumpNumbers.length} entries)</div>
                    </div>
                <div className={`h-pagenation h-pagenation-sub ${smallMedia ? "h-pagenation2" : ""}`} style={{border: "none"}}>
                    <button onClick={() => handleClick('prev')} disabled={currentPage === 1} className='constbtn' style={{fontSize: '14px'}}>Previous</button>
                    <div className="current-page pbtn active12a2a" style={small}>{currentPage}</div>
                    <button onClick={() => handleClick('next')} disabled={currentPage === totalPages} className='constbtn' style={{fontSize: '14px'}}>Next</button>
                </div>
            </div>
        </div>
    );
};

export default CleaningTable;
